import { CustomRule, helpers, } from 'vuelidate/lib/validators';

export const passwordRules = {
	length: helpers.withParams(
		{
			type: 'passwordLength',
			message: '10 or more characters.',
		},
		((value) => helpers.len(value) >= 10) as CustomRule,
	),
	uppercase: helpers.withParams(
		{
			type: 'uppercasePresent',
			message: 'An uppercase character.',
		},
		((value: string) => value !== value.toLocaleLowerCase()) as CustomRule,
	),
	lowercase: helpers.withParams(
		{
			type: 'lowercasePresent',
			message: 'A lowercase character.',
		},
		((value: string) => value !== value.toLocaleUpperCase()) as CustomRule,
	),
	number: helpers.withParams(
		{
			type: 'numberPresent',
			message: 'A number.',
		},
		((value: string) => /\d/.test(value)) as CustomRule,
	),
};
